import React from 'react';

import { twMerge } from 'tailwind-merge';

import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';

import JobStatusFilter from './job-status-filter';
import JobTypeFilter from './job-type-filter';
import FreelancersFilter from './freelancers-filter';
import OrganizationsFilter from './organizations-filter';
import LocationsFilter from './locations-filter';
import DateFilter from './date-filter';

interface SidebarFilterPropTypes {
  onDrawer?: boolean;
}

const SidebarFilter: React.FC<SidebarFilterPropTypes> = ({ onDrawer }) => {
  const {
    organizationPlannerSearchParams: { viewType },
  } = useOrganizationWeekPlanner();

  const className = twMerge(
    'px-6 py-6  bg-background-sidebar border-r border-gray100',
    onDrawer && ' xl:hidden',
    !onDrawer && 'hidden xl:block',
  );
  return (
    <div className={className}>
      <JobStatusFilter />

      <JobTypeFilter />

      <FreelancersFilter />

      <OrganizationsFilter />

      <LocationsFilter />

      {viewType === 'table' && <DateFilter />}
    </div>
  );
};

export default SidebarFilter;
